<template>
  <h2 class="section-title">最新消息</h2>
  <div class="latest-news">
    <div class="news-grid">
      <div v-for="news in newsItems" :key="news.date" class="news-item" >
        <!-- <img :src="require(`@/assets/${news.image}`)" :alt="news.title" class="news-image"> -->
        <img :src="getFullImageURL(news.news_image)" :alt="news.title" class="news-image" @error="onImageError"
        @click="goNewsDetail(news)">


        <!-- <div class="news-date " >{{ formatISODateToCustom(news.updated_at) }}</div> -->
        <div class="news-info">
          <div class="item-text-bold">{{ formatISODateToCustom(news.updated_at) }}</div>
          <div class="news-title item-text-bold"><NewsTitle :title="news.title" /> </div>
        </div>
      </div>
    </div>
    <!-- <button class="more-btn">更多最新消息</button> -->
    <button class="more-btn" @click="navigateToMore">更多最新消息</button>

  </div>
</template>

<script>
import { onImageError, getFullImageURL, formatISODateToCustom, logNewsClick } from '@/util/util';
import { globalParams } from '@/global';
import PullDAO from '@/services/PullDAO';
import NewsTitle from '@/components/home/NewsTitle.vue';

export default {
  name: 'LatestNews',
  components: {
    NewsTitle,
  },
  data() {
    return {
      newsItems: [], // Holds the fetched news data
      isLoading: false, // Tracks loading state
      error: null, // Tracks errors
      row: 8, // Number of items per page
      page: 1, // Current page for pagination
    };
  },
  methods: {
    formatISODateToCustom,
    onImageError,
    getFullImageURL,
    /**
     * Fetch news data from the NewsDAO
     */
    async fetchNews() {
      this.isLoading = true;
      this.error = null;

      const pullDAO = new PullDAO();

      console.log(this.newsItems);


      try {
        const newsData = await pullDAO.listNews(this.row, this.page);
        console.log(newsData);
        // Append the newly fetched news to the existing array
        this.newsItems = [...this.newsItems, ...newsData.news];
      } catch (error) {
        this.error = error.message || '無法加載最新消息。';
      } finally {
        this.isLoading = false;
      }
    },

    goNewsDetail(news) {
            logNewsClick(news, 'home');
            globalParams.shownNews = news;
            this.$router.push("/news-detail");
        },

    navigateToMore() {
    
    this.$router.push('/all-news'); // 導航到新的 AllNews 頁面
    },    
  },
  mounted() {
    // Fetch the initial batch of news when the component is created
    // wait 500ms 
    this.fetchNews();

  },
};
</script>

<style scoped>
.latest-news {
  display: block;
  /* padding: 40px 0; */
  /* width: 80%; */
  width: var(--home-component-width);
  margin: 0 auto;
  text-align: center;
}


.news-info {
  display: flex;
  flex-direction: column;
  /* justify-content: flex-start; */
  align-items: flex-start;
  /* text-align: left; */
}

.news-grid {
  display: grid;
  gap: 20px;
  margin-bottom: 30px;
}

.news-item {
  /* background-color: white; */
  background-color: transparent;
  overflow: hidden;
}

.news-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 15px 15px 0 0;

  border-radius: 15px;

}


.news-title {
  color: var(--gray15);
  margin-top:0px;

  white-space: nowrap; /* Prevent text from wrapping */
  overflow: hidden; /* Hide overflow text */
  text-overflow: ellipsis; /* Show ellipsis (...) for ov*/
  
  /* background-color: red; */
  text-align: left;
  width:100%

}



/* Desktop layout for screens larger than 560px */
@media (min-width: 560px) {

  /* .latest-news {
    width: 1416px;
    height: 576px;
  } */
  .news-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    /* Single horizontal row with four columns */
    gap: 20px;
    width: 100%;
    justify-content: center;
  }
}

/* Mobile layout for screens less than 560px */
@media (max-width: 560px) {
  .latest-news {
    width: 343px;
    /* height: 640px; */
  }

  .news-grid {
    display: flex;
    flex-direction: column;
    /* Stack items vertically */
    gap: 10px;
    width: 100%;
    margin-bottom: 0px;
  }

  .news-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 10px;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .news-image {
    width: 80px;
    height: 80px;
    border-radius: 10px;
    margin-right: 10px;
  }

  .news-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start; /* Align items to the start horizontally */
    justify-content: flex-start; /* Align items to the start vertically */
    gap: 5px;
    margin:0px;
    height:80px;

    /* background-color: red; */
  }

  .news-title {

    width:240px;
   
  }

  .item-text-bold {
    margin-top:0px;
    margin-bottom:0px;
   
  }




}
</style>
